"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBookedAppointmentsStore = void 0;
const pinia_1 = require("pinia");
const fetch_1 = __importDefault(require("../../../common/utils/fetch"));
const i18n_1 = __importDefault(require("../../../common/i18n"));
const date_fns_1 = require("date-fns");
const hexToRgba_1 = require("../../../common/utils/hexToRgba");
exports.useBookedAppointmentsStore = (0, pinia_1.defineStore)("bookedAppointmentsStore", {
    state: () => ({
        appointments: [],
        selectedDate: new Date(),
        detaildAppointment: null,
    }),
    getters: {
        newAppointments(state) {
            //Csak az új időpontok listázása a pinia storeból
            return state.appointments.filter((appointment) => appointment.status === "New");
        },
        getAppointmentsByServiceBayId: (state) => (bayId, selectedDate) => {
            //szűrés az adott szerviz állásra és a napra ami ki van választva
            let bayAppointments = state.appointments.filter((appointment) => {
                const appointmentDate = new Date(appointment.booked_date);
                const appointmentDateString = `${appointmentDate.getFullYear()}-${String(appointmentDate.getMonth() + 1).padStart(2, "0")}-${String(appointmentDate.getDate()).padStart(2, "0")}`;
                const newDateString = `${selectedDate.getFullYear()}-${String(selectedDate.getMonth() + 1).padStart(2, "0")}-${String(selectedDate.getDate()).padStart(2, "0")}`;
                return (appointment.bayId === bayId &&
                    appointmentDateString === newDateString &&
                    appointment.status !== "Deleted");
            });
            //store formátum átalakítása a fullcalendar komponensnek
            return bayAppointments.map((appointment) => {
                var _a;
                let start = (0, date_fns_1.format)(new Date(appointment.booked_date), "yyyy-MM-dd") +
                    "T" +
                    (0, date_fns_1.format)(new Date(appointment.booked_time), "HH:mm");
                let end = new Date(start);
                end = new Date(end.getTime() + appointment.duration * 60 * 1000);
                return {
                    id: appointment.id,
                    gyarto: appointment.car_make,
                    modell: appointment.car_model,
                    rendszam: appointment.plate_number,
                    isWheel: appointment.is_wheel,
                    bayId: appointment.bayId,
                    start: start,
                    end: `${end.getFullYear()}-${("0" +
                        (end.getMonth() + 1)).slice(-2)}-${("0" + end.getDate()).slice(-2)}T${("0" + end.getHours()).slice(-2)}:${("0" + end.getMinutes()).slice(-2)}:00`,
                    from: appointment.source,
                    status: appointment.status,
                    serviceId: appointment.serviceId,
                    color: (_a = (0, hexToRgba_1.hexToRgba)(appointment.sourceColor, 0.2)) !== null && _a !== void 0 ? _a : "",
                    borderColor: appointment.sourceColor,
                };
            });
            //return bayAppointments;
        },
    },
    actions: {
        getAppointments(locationId) {
            this.appointments = [];
            return new Promise((resolve, reject) => {
                (0, fetch_1.default)("/api/get/booked-appointments/" + locationId + "/home", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    //body: JSON.stringify({ userCode: userCode }),
                })
                    .then((response) => {
                    if (typeof response.error !== "undefined") {
                        reject(i18n_1.default.trans("frontend_location_error", "No appointments found!", "frontend"));
                        return;
                    }
                    response.forEach((item) => {
                        this.appointments.push(item);
                    });
                    resolve();
                })
                    .catch((error) => {
                    reject(error);
                });
            });
        },
        getAppointmentsForClendar(locationId, date) {
            this.appointments = [];
            return new Promise((resolve, reject) => {
                (0, fetch_1.default)("/api/get/booked-appointments/" +
                    locationId +
                    "/calendar", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ date: date }),
                })
                    .then((response) => {
                    if (typeof response.error !== "undefined") {
                        reject(i18n_1.default.trans("frontend_location_error", "No appointments found!", "frontend"));
                        return;
                    }
                    response.forEach((item) => {
                        this.appointments.push(item);
                    });
                    resolve();
                })
                    .catch((error) => {
                    reject(error);
                });
            });
        },
        acceptAppointment(appointmentId) {
            if (appointmentId) {
                return new Promise((resolve, reject) => {
                    (0, fetch_1.default)("api/appointments/accept/" + appointmentId, {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        //body: JSON.stringify({ userCode: userCode }),
                    })
                        .then((response) => {
                        if (typeof response.error !== "undefined") {
                            reject(i18n_1.default.trans("backend_appointment_error", "Something went wrong!", "backend"));
                            return;
                        }
                        const appointments = [...this.appointments];
                        const appointmentIndex = appointments.findIndex((app) => app.id === appointmentId);
                        if (appointmentIndex !== -1) {
                            const updatedAppointment = {
                                ...appointments[appointmentIndex],
                                status: response.status,
                                statusId: response.statusId,
                            };
                            appointments[appointmentIndex] =
                                updatedAppointment;
                            this.appointments = appointments;
                            if (this.detaildAppointment !== null &&
                                this.detaildAppointment.id ===
                                    appointmentId) {
                                const detaildAppointmentCopy = {
                                    ...this.detaildAppointment,
                                    status: response.status,
                                    statusId: response.statusId,
                                };
                                this.detaildAppointment =
                                    detaildAppointmentCopy;
                            }
                        }
                        resolve();
                    })
                        .catch((error) => {
                        reject(error);
                    });
                });
            }
        },
        declineAppointment(appointmentId) {
            if (appointmentId) {
                return new Promise((resolve, reject) => {
                    (0, fetch_1.default)("api/appointments/reject/" + appointmentId, {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        //body: JSON.stringify({ userCode: userCode }),
                    })
                        .then((response) => {
                        if (typeof response.error !== "undefined") {
                            // refresh failed
                            reject(i18n_1.default.trans("backend_appointment_error", "Something went wrong!", "backend"));
                            return;
                        }
                        const appointments = [...this.appointments];
                        const appointmentIndex = appointments.findIndex((app) => app.id === appointmentId);
                        if (appointmentIndex !== -1) {
                            const updatedAppointment = {
                                ...appointments[appointmentIndex],
                                status: response.status,
                                statusId: response.statusId,
                            };
                            appointments[appointmentIndex] =
                                updatedAppointment;
                            this.appointments = appointments;
                            if (this.detaildAppointment !== null &&
                                this.detaildAppointment.id ===
                                    appointmentId) {
                                const detaildAppointmentCopy = {
                                    ...this.detaildAppointment,
                                    status: response.status,
                                    statusId: response.statusId,
                                };
                                this.detaildAppointment =
                                    detaildAppointmentCopy;
                            }
                        }
                        resolve();
                    })
                        .catch((error) => {
                        reject(error);
                    });
                });
            }
        },
        deleteAppointment(appointmentId) {
            if (appointmentId) {
                return new Promise((resolve, reject) => {
                    (0, fetch_1.default)("api/appointments/delete/" + appointmentId, {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        //body: JSON.stringify({ userCode: userCode }),
                    })
                        .then((response) => {
                        if (typeof response.error !== "undefined") {
                            // refresh failed
                            reject(i18n_1.default.trans("backend_appointment_error", "Something went wrong!", "backend"));
                            return;
                        }
                        /*this.appointments = this.appointments.filter(
          (app) => app.id !== appointmentId
        );

        if (
          this.detaildAppointment !== null &&
          this.detaildAppointment.id === appointmentId
        ) {
          this.detaildAppointment = null;
        }*/
                        const appointments = [...this.appointments];
                        const appointmentIndex = appointments.findIndex((app) => app.id === appointmentId);
                        if (appointmentIndex !== -1) {
                            const updatedAppointment = {
                                ...appointments[appointmentIndex],
                                status: response.status,
                                statusId: response.statusId,
                            };
                            appointments[appointmentIndex] =
                                updatedAppointment;
                            this.appointments = appointments;
                            if (this.detaildAppointment !== null &&
                                this.detaildAppointment.id ===
                                    appointmentId) {
                                const detaildAppointmentCopy = {
                                    ...this.detaildAppointment,
                                    status: response.status,
                                    statusId: response.statusId,
                                };
                                this.detaildAppointment =
                                    detaildAppointmentCopy;
                            }
                        }
                        resolve();
                    })
                        .catch((error) => {
                        reject(error);
                    });
                });
            }
        },
        saveSelectedDate() {
            sessionStorage.setItem("selectedDate", JSON.stringify(this.selectedDate));
        },
        readSelectedDate() {
            const storageSelectedDate = sessionStorage.getItem("selectedDate");
            if (storageSelectedDate) {
                this.selectedDate = new Date(JSON.parse(storageSelectedDate));
            }
        },
        getDetaildAppointment(locationId, appointmentId) {
            //ha nem szám érték jön akkor visszatér üresen
            if (!locationId ||
                !appointmentId ||
                isNaN(appointmentId) ||
                isNaN(locationId)) {
                return;
            }
            return new Promise((resolve, reject) => {
                (0, fetch_1.default)("api/get/detaild-appointment/" +
                    locationId +
                    "/" +
                    appointmentId, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    //body: JSON.stringify({ userCode: userCode }),
                })
                    .then((response) => {
                    if (typeof response.error !== "undefined") {
                        // refresh failed
                        reject(i18n_1.default.trans("backend_appointment_error", "Something went wrong!", "backend"));
                        return;
                    }
                    if (response && response !== null) {
                        const convertedResponse = this.convertShopResponseType(response);
                        this.detaildAppointment = convertedResponse;
                    }
                    resolve();
                })
                    .catch((error) => {
                    reject(error);
                });
            });
        },
        convertShopResponseType(response) {
            return {
                id: response.id,
                plate_number: response.plate_number,
                car_make_slug: response.car_make_slug,
                car_model_slug: response.car_model_slug,
                car_type_slug: response.car_type_slug,
                car_make: response.car_make,
                car_model: response.car_model,
                car_type: response.car_type,
                car_year: parseInt(response.car_year),
                comment: response.comment,
                is_wheel: response.is_wheel,
                booked_date: new Date(response.booked_date),
                booked_time: new Date(response.booked_time),
                source: response.source.source,
                sourceColor: response.source.color,
                created_at: response.created_at,
                bayId: response.bayId,
                bayName: response.bayName,
                email: response.email,
                status: response.status,
                statusId: response.statusId,
                duration: response.service_duration,
                invoice: response.invoice,
                is_runflat: response.is_runflat,
                is_stored: response.is_stored,
                is_tpms: response.is_tmps,
                name: response.name,
                phone: response.phone,
                rim_size: parseInt(response.rim_size),
                serviceId: response.serviceId,
                service_duration: response.service_duration,
                service_name: response.service_name,
                tyre_type: response.tyre_type,
                locationId: parseInt(response.locationId),
            };
        },
        async pasteEvent(id, start, end, serviceBay) {
            return new Promise((resolve, reject) => {
                (0, fetch_1.default)("api/appointments/paste", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        id: id,
                        start: (0, date_fns_1.format)(start, "yyyy-MM-dd HH:mm"),
                        end: (0, date_fns_1.format)(end, "yyyy-MM-dd HH:mm"),
                        serviceBay: serviceBay,
                    }),
                })
                    .then((response) => {
                    if (typeof response.error !== "undefined") {
                        // refresh failed
                        reject(i18n_1.default.trans("backend_appointment_paste_error", "Something went wrong, when the event pasted!", "backend"));
                        return;
                    }
                    if (response.status == "success") {
                        const updatedAppointments = [
                            ...this.appointments,
                        ];
                        const appointmentIndex = updatedAppointments.findIndex((event) => event.id ===
                            response.modifiedDatas.id);
                        if (appointmentIndex !== -1) {
                            const updatedAppointment = {
                                ...updatedAppointments[appointmentIndex],
                                bayId: response.modifiedDatas.bayId,
                                booked_date: response.modifiedDatas.booked_date,
                                booked_time: response.modifiedDatas.booked_time,
                                duration: response.modifiedDatas.duration,
                                bayName: response.modifiedDatas.bayName,
                            };
                            updatedAppointments[appointmentIndex] =
                                updatedAppointment;
                        }
                        this.appointments = updatedAppointments;
                    }
                    resolve();
                })
                    .catch((error) => {
                    reject(error);
                });
            });
        },
        async saveAppointment(appointment) {
            const error = this.validateBackendAppointmentSave(appointment);
            if (error) {
                throw new Error(error);
            }
            return new Promise((resolve, reject) => {
                (0, fetch_1.default)("api/admin/appointments/save", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        appointment: appointment,
                    }),
                })
                    .then((response) => {
                    if (typeof response.error !== "undefined") {
                        // refresh failed
                        reject(i18n_1.default.trans("backend_appointment_save_error", "Something went wrong, when the event saved!", "backend"));
                        return;
                    }
                    resolve();
                })
                    .catch((error) => {
                    reject(error);
                });
            });
        },
        validateBackendAppointmentSave(appointment) {
            if (!appointment.booked_date) {
                return i18n_1.default.trans("backend_appointment_date_error", "Appointment date is reqired!", "backend");
            }
            if (!appointment.booked_time) {
                return i18n_1.default.trans("backend_appointment_time_error", "Appointment time is reqired!", "backend");
            }
            if (!appointment.serviceId && !appointment.id) {
                return i18n_1.default.trans("backend_service_error", "Service is reqired!", "backend");
            }
        },
    },
});
